<template>
  <div>
    <div id="tabBox" class="clearfix">
      <div class="tabBox boxcenter fl">
        <ul>
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="{on:isNavChecked == item.value}"
            @mouseenter="enter(index)"
            @mouseleave="leave(index)"
            @click.capture="getTopNav({value:item.value,name:item.name})"
          >
            <span>{{item.name}}</span>
          </li>
        </ul>
      </div>
      <div class="block pcBlock fr" v-if="isPC" style="margin-top:20px;">
        <span class="demonstration" style="font-size:18px;">选择时间：</span>
        <el-date-picker
          v-model="value2"
          type="month"
          value-format="yyyy-MM"
          :placeholder="endTime"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
    </div>

    <div id="main">
      <div class="main clearfix">
        <div class="mainconn mainConn1">
          <div class="mainLTab fl">
            <ul>
              <li
                @click="leftNavChecked(item,index)"
                :class="{on:idLeftNavChecked == index}"
                v-for="(item,index) in navLeftList"
                :key="index"
              >{{item}}</li>
            </ul>
            <div v-if="(!isPC)" class="mBlock">
              <span class="mBlockSpan" @click="openPicker()">{{value2}}</span>
              <mt-datetime-picker
                ref="picker"
                v-model="pickerVisible"
                type="date"
                year-format="{value} 年"
                month-format="{value} 月"
                :startDate="new Date(startTime)"
                :endDate="new Date(endTime)"
                @confirm="handleConfirm"
              ></mt-datetime-picker>
            </div>
          </div>
          <div class="mainRConn fl">
            <div class="mainRConnBox mainRConn1">
              <table class="mainRTable mainRTable1" v-if="isPC">
                <thead>
                  <tr>
                    <td>排名</td>
                    <td></td>
                    <td>产品名称</td>
                    <td>公司名称</td>
                    <td>保障期间</td>
                    <td>缴费期</td>
                    <td>评级</td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    @click="gotoDetail(item.productNo,item.orgName)"
                    v-for="(item,index) in monthList"
                    :key="index"
                    name="item.productNo"
                  >
                    <td>{{(index > 2) ? index+1 : ""}}</td>
                    <td class="bxcpLOGO">
                      <img :src="item.logo_url" />
                    </td>
                    <td class="bxcpName">{{item.name}}</td>
                    <td class="companyName">{{item.orgName}}</td>
                    <td>{{item.insurePeriod}}</td>
                    <td>{{item.payTime}}</td>
                    <td>
                      <img
                        :src="'http://www.cfbond.com/static/images/sybx_star('+item.grade.length+').png'"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <ul v-if="!isPC">
                <li
                  @click="gotoDetail(item.productNo,item.orgName)"
                  v-for="(item,index) in monthList"
                  :key="index"
                >
                  <div class="bxcpLOGO fl">
                    <img :src="item.logo_url" />
                  </div>
                  <div class="bxcpListConn fl">
                    <p class="bxcpName">{{item.name}}</p>
                    <p class="companyName">{{item.orgName}}</p>
                  </div>
                  <div class="bxcpStar">
                    <img
                      :src="'http://www.cfbond.com/static/images/sybx_star('+item.grade.length+').png'"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //日期选择器
      pickerVisible: "",
      startTime: "2018-09",
      endTime: "",
      value2: "",
      navList: [
        {
          name: "重大疾病保险",
          value: 0
        },
        {
          name: "定期寿险",
          value: 1
        },
        {
          name: "终身寿险",
          value: 2
        }
      ],
      //主nav是否选中
      isNavChecked: 0,
      //副nav是否显示
      isNav1Show: false,
      //左侧nav
      navLeftList: ["综合榜", "价格榜"],
      idLeftNavChecked: 0,
      //月度榜单数据
      monthList: [],

      //参数
      params: {
        insurance_type: "重大疾病保险",
        rank_type: "综合榜",
        ym: ""
      },
      pickerOptions: {
        disabledDate: time => {
          return (
            time.getTime() < new Date(this.startTime) ||
            time.getTime() > new Date(this.endTime)
          );
        }
      },
      //判断页面尺寸
      isPC: document.body.clientWidth > 768 ? true : false
    };
  },
  created() {
    // this.getMonthList();
    this.endTime = this.getEndTime();
    this.value2 = this.getEndTime();
    this.pickerVisible = new Date(this.getEndTime());
    this.params.ym = this.value2.slice(2).replace("-", "");
  },
  mounted() {},
  methods: {
    enter(index) {
      if (index == 0) {
        this.isNav1Show = true;
      }
    },
    leave(index) {
      if (index == 0) {
        this.isNav1Show = false;
      }
    },
    getTopNav(item) {
      this.isNavChecked = item.value;
      this.params.insurance_type = item.name;
    },
    getTopNav1(item) {
      this.getTopNav(item);
      this.params.insurance_type = item.name;
      this.isNav1Show = false;
      this.insurance_type1 = item.name;
    },
    //价格榜、综合榜选择
    leftNavChecked(item, index) {
      this.idLeftNavChecked = index;
      this.params.rank_type = item;
    },
    getMonthList() {
      this.axios
        .get("App.insurance_list_ym.action", {
          params: this.params
        })
        .then(result => {
          this.monthList = result.data.data;
        });
    },
    //查看详情页
    gotoDetail(num, name) {
      this.$router.push({
        name: "detail",
        query: {
          product_no: num,
          rank_type: this.params.rank_type,
          company_name: name,
          ym: this.params.ym
        }
      });
    },
    openPicker() {
      this.$refs.picker.open();
      let a = document.getElementsByClassName("picker-slot");
      for (let i = 0; a && i < a.length; i++) {
        if (i == 2) {
          a[i].style.display = "none";
        }
      }
    },
    // 格式化获取的时间
    formatDate(date) {
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      // let d = date.getDate();
      // d = d < 10 ? "0" + d : d;
      return y + "-" + m;
    },
    getEndTime() {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth();
      m = m < 10 ? "0" + m : m;
      if (m == 0) {
        y = y - 1;
        m = 12;
      }
      return y + "-" + m;
    },
    //点击确定按钮之后
    handleConfirm() {
      // 输出格式化后的时间
      this.value2 = this.formatDate(this.$refs.picker.value);
    }
  },
  watch: {
    value2: {
      handler(newVal, oldVal) {
        this.params.ym =
          this.value2 != null
            ? this.value2.slice(2).replace("-", "")
            : this.endTime.slice(2).replace("-", "");
      }
    },
    params: {
      deep: true,
      handler(newVal, oldVal) {
        this.getMonthList();
      }
    }
  }
};
</script>

<style scoped>
.mBlock {
  display: none;
}
#tabBox {
  width: 1130px;
  margin: 30px auto 50px;
}
.tabBox {
  width: 650px;
  height: 78px;
  background: url(../../images/bxcp_tabBg.png) no-repeat;
  margin-left: 150px;
}

.tabBox ul li {
  float: left;
  width: 33.33%;
  text-align: center;
  line-height: 78px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  position: relative;
}

.tabBox ul li span {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 99;
}

.tabBox ul li.on span,
.tabBox ul li:hover span {
  background: url(../../images/bxcp_tabLi_bg.png) no-repeat center;
  color: #fff;
}

.tabBox .bx1List {
  position: absolute;
  background: #ffe7d0;
  width: 134px;
  padding: 30px 15px 5px;
  border-radius: 6px;
  left: 27px;
  top: 40px;
  z-index: 98;
}

.tabBox .bx1List p {
  line-height: 39px;
  font-size: 16px;
  color: #000;
  font-weight: normal;
  border-bottom: 1px solid #f2dbc5;
}

.tabBox .bx1List p:last-child {
  border-bottom: 0;
}
.main {
  position: relative;
  margin: 0 auto;
  width: 1200px;
}

.main .mainLTab {
  width: 142px;
  background: url(../../images/bxcp_mainLTabBg.png) no-repeat;
  height: 738px;
  margin-right: 50px;
}

.main .mainLTab ul li {
  height: 56px;
  line-height: 56px;
  color: #373737;
  text-align: center;
  cursor: pointer;
}

.main .mainLTab ul li.on {
  background: #ff8109;
  color: #fff;
}

.mainRConn {
  width: 1000px;
}

.mainRConn table {
  width: 100%;
  text-align: center;
  color: #373737;
  font-size: 16px;
  -table-layout: fixed;
}

.mainRConn table thead {
  font-weight: bold;
}

.mainRConn table thead tr {
  height: auto;
}

.mainRConn table tr {
  height: 120px;
}

.mainRConn table tr td:first-child {
  width: 50px;
}

.mainRConn table tbody tr {
  cursor: pointer;
}

.mainRConn table tbody tr:first-child td:first-child {
  background: url(../../images/bxcp_level1.png) no-repeat center;
}

.mainRConn table tbody tr:nth-child(2) td:nth-child(1) {
  background: url(../../images/bxcp_level2.png) no-repeat center;
}

.mainRConn table tbody tr:nth-child(3) td:nth-child(1) {
  background: url(../../images/bxcp_level3.png) no-repeat center;
}

.bxcpLOGO img {
  width: 80px;
}

.bxcpName {
  width: 230px;
  -text-align: left;
}

.mainRConnBox ul {
  display: none;
}
@media screen and (min-width: 100px) and (max-width: 768px) {
  .pcBlock {
    display: none;
  }
  .mBlock {
    display: block;
    position: absolute;
    right: 10px;
    top: 0;
  }
  .mBlockSpan {
    display: block;
    height: 30px;
    background: #fff;
    padding-left: 5px;
    border-radius: 8px;
    line-height: 30px;
    font-size: 14px;
    padding-right: 15px;
    position: relative;
  }
  .mBlockSpan::after {
    display: block;
    content: "";
    border: 4px solid transparent;
    border-top: 4px solid #bbb;
    position: absolute;
    right: 2px;
    top: 13px;
  }
  #tabBox {
    width: 100%;
    margin: 0;
  }
  .tabBox {
    height: 90px;
    background: #fff;
    width: 100%;
    margin: 0;
  }
  .tabBox ul {
    padding: 10px 0;
  }
  .tabBox ul li .bx1List {
    display: none !important;
  }
  .tabBox ul li:last-child {
    background: url(../../images/bxcp_m_zssx.png) no-repeat top center;
    background-size: auto 60%;
  }
  .tabBox ul li:nth-child(2) {
    background: url(../../images/bxcp_m_dqsx.png) no-repeat top center;
    background-size: auto 60%;
  }
  .tabBox ul li:first-child {
    background: url(../../images/bxcp_m_zszjx.png) no-repeat top center;
    background-size: auto 60%;
  }
  .tabBox ul li:last-child.on {
    background: url(../../images/bxcp_m_zssx_on.png) no-repeat top center;
    background-size: auto 60%;
  }
  .tabBox ul li:nth-child(2).on {
    background: url(../../images/bxcp_m_dqsx_on.png) no-repeat top center;
    background-size: auto 60%;
  }
  .tabBox ul li:first-child.on {
    background: url(../../images/bxcp_m_zszjx_on.png) no-repeat top center;
    background-size: auto 60%;
  }
  .tabBox ul li {
    /* float: right; */
    padding-top: 60px;
    line-height: 0;
    margin: 0;
  }
  .tabBox ul li.on span {
    background: none;
    color: #000;
  }
  .tabBox ul li span {
    font-size: 12px;
    color: #000;
  }

  .main {
    width: 100%;
  }
  .mainLTab,
  .mainRConn {
    float: none !important;
  }
  .main .mainLTab {
    height: 30px;
    margin: 8px 0;
    text-align: center;
    width: 100%;
    background: none;
    position: relative;
  }
  .main .mainLTab ul {
    width: 100%;
    text-align: center;
  }
  .main .mainLTab ul li {
    float: none;
    display: inline-block;
    width: 23.5%;
    margin-right: 0px;
    height: 30px;
    line-height: 30px;
    font-size: 15px;
    background: #fff;
  }
  .main .mainLTab ul li:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  .main .mainLTab ul li:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
  .main .mainRConn,
  .mainRConnBox {
    background: #fff;
    width: 100%;
  }
  .mainRTable {
    display: none;
  }
  .mainRConnBox ul {
    display: block;
  }
  .mainRConnBox ul li {
    height: 75px;
    padding: 15px 10px;
    margin-bottom: 2px;
    overflow: hidden;
  }
  .mainRConnBox ul li .bxcpLOGO {
    width: 23%;
    display: flex;
    align-items: center;
    justify-content: start;
    height: 100%;
  }
  .mainRConnBox ul li .bxcpLOGO img {
    width: 70%;
    vertical-align: middle;
  }
  .mainRConnBox ul li .bxcpListConn {
    width: 54%;
  }
  .mainRConnBox ul li .bxcpName {
    line-height: 20px;
    font-size: 15px;
    width: 100%;
    margin-bottom: 10px;
    height: 40px;
  }
  .mainRConnBox ul li .companyName {
    font-size: 14px;
    color: #797979;
  }
  .mainRConnBox ul li .bxcpStar {
    width: 23%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .mainRConnBox ul li .bxcpStar img {
    height: 20%;
  }
  #main {
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/itemList/monthList.vue